<div class="alert alert-success" *ngIf="alertDeleteSuccess">
  Event deleted successfully!
</div>
<div class="alert alert-success" *ngIf="alertCloseSuccess">
  Event closed successfully!
</div>
<div class="alert alert-success" *ngIf="alertCancelSuccess">
  Event cancelled successfully!
</div>
<div class="alert alert-success" *ngIf="alertCancelAllSuccess">
  Event Series cancelled successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="common-padding">
<div class= "top-section">
  <h4>EVENTS</h4>
  <button type="button" class ="btn btn-danger btn-style" (click)="clearEditEventData()" routerLink="../create-event">CREATE EVENT</button>
</div>
<div id='included_page' class="form-outer-div">
  <div class="form-group-div">
<span>
    <ng-select placeholder ="--Select SITE--"  class="custom" [items] = "siteList" bindLabel ="siteName" bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)" ></ng-select> 
 </span>
 </div>

 <div class="form-group-div">

  <div>
    <ng-select placeholder ="--Select BPG--"  class="custom" [items] = "bpgList" bindLabel ="bpgName" bindValue="bpgId" [(ngModel)]="bpgId" (change)="bpgChange($event)" ></ng-select> 
  </div>
 </div>

  <div class="form-group-div" >
    <ng-select  placeholder ="--Select Status--"  class="custom" [items] = "statusList" bindLabel ="status" bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)" ></ng-select> 
  </div>

  
  <div class="form-group-div">
      <input type="text" class="form-control keywords" autocomplete="off" id="search" placeholder="Search by event name" [(ngModel)]="searchKey">
    </div>
    <div id="searchSecn">
      <button type="button" class="btn btn-danger" (click)="searchEvents()">Search</button>
    </div>


</div>

</div>
<p class="noDataFound" *ngIf="noDataFound"> No data found </p>
  <div class="table-data" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
        <th scope="col"  (click)="sortMe('sm.site_name')">Site <span class="sortupdown"><i id="sm.site_name1"
          class="fa fa-sort-up"></i><i id="sm.site_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col" (click)="sortMe('bm.bpg_name')">BPG <span class="sortupdown"><i id="bm.bpg_name1"
           class="fa fa-sort-up"></i><i id="bm.bpg_name2" class="fa fa-sort-down"></i></span></th>
        <th scope="col" (click)="sortMe('event_name')">Event Name <span class="sortupdown"><i id="event_name1"
          class="fa fa-sort-up"></i><i id="event_name2" class="fa fa-sort-down"></i></span></th>
          <th scope="col" (click)="sortMe('created_date_time')">Created Date <span class="sortupdown"><i id="created_date_time1"
            class="fa fa-sort-up"></i><i id="created_date_time2" class="fa fa-sort-down"></i></span></th>
          <th scope="col" (click)="sortMe('event_create_date')">Event Date <span class="sortupdown"><i id="event_create_date1"
            class="fa fa-sort-up"></i><i id="event_create_date2" class="fa fa-sort-down"></i></span></th>
        <th scope="col">Created By</th>
        <th scope="col">Status</th>
        <th scope="col">Action</th>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of eventsData | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
            <td>{{data.siteName}}</td>
            <td>{{data.bpgName}}</td>
            <td>{{data.eventName}}</td>
            <td>{{data.dateSubmitted | date:'MM-dd-yyyy'}}</td>
            <td>{{data.eventCreateDate | date:'MM-dd-yyyy'}}</td>
            <td>{{data.createdByAdminFirstName + " " +data.createdByAdminLastName}}</td>
            <td>{{data.eventStatus}}</td>
            <td>
            
              <a (click)="viewEventDetails(data.eventId,'VIEW')" class="viewButton" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus!='NEW' && data.eventStatus!='REJECTED')"><img src="assets/images/view.png" class="image" title="View" alt="Angular Logo"></a>
              <a (click)="editEvent(data)" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus!='COMPLETED'&&data.eventStatus!='CLOSED'&&data.eventStatus!='CANCELLED')&&(data.eventCreateDate > previousDate)" [hidden]="(data.startTime < currentTime) && (data.eventCreateDate == currentDate)" routerLink="../create-event" class="editButton"><img src="assets/images/edit.png" class="image" title="Edit" alt="Angular Logo"></a>
              <a (click)="editAllEvent(data)" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&& (data.occurenceType!='once') && (data.eventStatus!='COMPLETED'&&data.eventStatus!='CLOSED'&&data.eventStatus!='CANCELLED')&&(data.eventCreateDate > previousDate)" [hidden]="(data.startTime < currentTime) && (data.eventCreateDate == currentDate)" routerLink="../create-event" class="editButton"><img src="assets/images/edit-all.png" alt="Angular Logo" class="image" title="EditAll"></a>
              <a (click)="deleteClick(data.eventId)" class="deleteButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='NEW'||data.eventStatus=='REJECTED')"><img src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
              <a (click)="completeClick(data.eventId,'COMPLETE')" class="completeButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==4||isbpgLeadAdmin||isNaacAdmin||data.isUserChapterLeadAdmin==true)&&(data.eventStatus=='COMPLETED')&&(data.eventAttendanceLoadCompleted==true)"><img src="assets/images/complete.png" alt="Angular Logo" class="image" title="Close"></a>
              <a (click)="viewEventDetails(data.eventId,'ATTENDENCE')" class="attendanceButton" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgAdmin||isbpgLeadAdmin||isNaacAdmin||data.isUserChapterLeadAdmin==true)&&(data.eventStatus=='APPROVED')&&(data.eventCreateDate <= today)" ><img src="assets/images/attendance.png" alt="Angular Logo" class="image" title="Attendance"></a>
              <a (click)="cancelClick(data.eventId,'CANCELLED')" class="cancelButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='APPROVED')&&(data.eventCreateDate > previousDate)"  [hidden]="(data.startTime < currentTime) && (data.eventCreateDate == currentDate)" ><img src="assets/images/reject.png" alt="Angular Logo" class="image" title="Cancel"></a>
              <a (click)="cancelAllClick(data.eventId,data.eventGroupId)" class="cancelButton" data-toggle="modal" data-target="#myModal" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&(data.eventStatus=='APPROVED')&&(data.eventCreateDate > previousDate) && (data.occurenceType!='once')"  [hidden]="(data.startTime < currentTime) && (data.eventCreateDate == currentDate)" ><img src="assets/images/cancel-all.png" class="image" alt="Angular Logo" title="Cancel All"></a>
              <a (click)="eventReportClick(data.eventId)" class="cancelButton"><img src="assets/images/event_report.png" class="image" alt="Angular Logo" *ngIf="(adminId==1||adminId==2||adminId==3||adminId==4||isbpgLeadAdmin||isbpgAdmin||isNaacAdmin)&&((data.eventStatus=='APPROVED')||(data.eventStatus=='COMPLETED')||(data.eventStatus=='CLOSED')||(data.eventStatus=='CANCELLED'))" title="Event Report"></a>

            </td>
          </tr>

    </tbody>
  </table>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

</div>

<div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>


